import { Select } from '@trackman/web-shared-components';
import { useTranslation } from 'react-i18next';
import { ClassesList } from 'types/organization/classes';

type Props = {
  value: string;
  onChange: (newValue: string) => void;
  classesList: ClassesList;
};
export const SelectClass = ({ value, onChange, classesList }: Props) => {
  const { t } = useTranslation();

  return (
    <Select
      label={t('SelectClass', { ns: 'organizationPage' })}
      value={value}
      onChange={(event) => onChange(event.target.value as string)}
      selectOptions={classesList.map((classItem) => {
        return {
          label: classItem.name === ' ' ? t('PleaseSelectClass', { ns: 'organizationPage' }) : classItem.name,
          value: classItem.id,
        };
      })}
    />
  );
};
